import React from 'react'
import { Link } from 'react-router-dom'
import { PIPELINE_STAGES } from '../../helpers'

// Recruitment shown as a candidate pipeline. The shared first stage ("Prospekt")
// is seeded by a Kunder flag and/or the recruitment app's `potential` milestone;
// later stages come from the recruitment app's kandidat_milestone events — both
// fold in via projectPipeline, so this component doesn't change per source.
// Takes the already-computed projection (projectPipeline) from the parent so it
// isn't recomputed on every render. Renders nothing when there's no pipeline
// (parent hides the section anyway).
export const RecruitmentPipeline = ({ pipeline: p }) => {
  if (!p) return null

  const stagePill = p.terminal
    ? { text: p.terminal.label.toUpperCase(), cls: 'network-stage-pill terminal' }
    : p.interestOnly
      ? { text: (PIPELINE_STAGES[0]?.label || '').toUpperCase(), cls: 'network-stage-pill interest' }
      : { text: (p.currentStage?.label || '').toUpperCase(), cls: 'network-stage-pill active' }

  return (
    <div className="network-inv-row network-pipeline">
      <div className="network-pipeline-head">
        <span className="network-pipeline-title">
          {p.interestOnly ? '🎯' : '👤'} Rekryteringspipeline
        </span>
        <span className={stagePill.cls}>{stagePill.text}</span>
      </div>

      <div className="network-stepper" role="list">
        {PIPELINE_STAGES.map((s, i) => {
          const reached = p.reached.has(s.code)
          const state = !reached ? 'todo' : i === 0 ? 'origin' : 'done'
          return (
            <div className={`network-step ${state}`} key={s.code} role="listitem">
              <span className="network-step-dot" />
              <span className="network-step-label">{s.label}</span>
            </div>
          )
        })}
      </div>

      {p.provenance.length > 0 && (
        <div className="network-pipeline-prov">
          Flaggad via {p.provenance.map((c, i) => (
            <span key={c.client_slug || c.client_name || i}>
              {i > 0 && ' · '}
              {c.client_name}{c.count > 1 && <span className="network-prov-count"> ×{c.count}</span>}
            </span>
          ))}
        </div>
      )}

      {p.candidateUuid && (
        <Link className="network-inv-link" to={`/recruitment/${p.candidateUuid}`}>Visa kandidat →</Link>
      )}
    </div>
  )
}
